<template>
  <div class="dynamic">
    <div class="dynamic_title">{{$t("homeAbout.dynamic")}}</div>
    <div class="dynamic_sub">{{$t("homeAbout.dynamicSub")}}</div>
    <div class="introduced">
      <div class="introduced_left">
        <div class="each" @click="handleNavigate('/four', index + 1)" v-for="(item,index) in companyDynamicsLeft" :key="index">
          <div class="picture">
            <img :src="item.img" alt=""/>
          </div>
          <div class="describes">
            <div class="title">{{item.title}}</div>
            <div class="details">{{item.profile}}</div>
            <div class="more">{{$t("homeAbout.lookMore")}}</div>
          </div>
        </div>
      </div>
      <div class="introduced_right">
        <div class="each" @click="handleNavigate('/four', index + 3)" v-for="(item,index) in companyDynamicsRight" :key="index" :class="{'marginBottom':companyDynamicsRight.length-1 === index}">
          <div class="picture">
            <img :src="item.img" alt=""/>
          </div>
          <div class="describes">
            <div class="title">{{item.title}}</div>
            <div class="details">{{item.profile}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    companyDynamicsLeft()
    {
      return [
        {
          title: "Lady Athena Hung，Dato’ Sri, 2025Asia-Pacific Leaders Conference",
          profile:'On April 8, 2025, the International Investment Salon of the Asia-Pacific Leaders Conference, hosted by Dr. Lawrence Yu, Founder of the Asia-Pacific Leaders Conference and Asia-Pacific Leaders Forum and Independent Director of the U.S. Rogers Pickleball Fund, grandly opened at the CFC Changfu Jinmao Building in Shenzhen. The event brought together more than 30 entrepreneurs, investors, financiers, and representatives from the cultural and sports sectors of China, Singapore, the United States, South Korea and other countries. Through the collision of cutting-edge ideas and in-depth cooperation discussions, they jointly explored new investment opportunities in the Asia-Pacific region.',
          img:require("@/assets/img/article/0629/3.webp")
        },
        {
          title: '洪子晴爵士出席亚太领袖会2025国际投资沙龙&并担任亚太经济领袖联合会永远荣誉主席',
          profile:'2025年4月8日，由亞太領袖會暨亚太领袖论坛创始人、美国罗杰斯匹克球基金独董劳伦斯.余博士主办的亚太领袖会国际投资沙龙于深圳CFC长富金茂大厦盛大启幕。活动汇聚中国、新加坡、美国、韩国等30余位企业家、投资家、金融家及文体界代表，通过前沿观点碰撞与深度合作探讨，共拓亚太投资新机遇。',
          img:require("@/assets/img/article/0629/4.webp")
        }
      ]
    },
    companyDynamicsRight()
    {
      return [
        {
          title: '洪子晴爵士与瑞典前首相约翰·弗雷德里克·赖因费尔特在上海相聚',
          profile:'2025年5月27日，上海迎来了一位重要的国际友人 —— 瑞典第八任首相约翰・弗雷德里克・赖因费尔特阁下。此次访华，赖因费尔特阁下带着促进中瑞交流合作的愿景，行程紧凑且意义非凡。',
          img:require("@/assets/img/article/0615/10.webp")
        },
        {
          title: '洪子晴爵士应邀出席2025年云南省西双版纳傣族自治州产业招商引资推介会',
          profile:'2025年4月26日，云南省西双版纳傣族自治州产业招商引资推介会在深圳市盛大举行，来自各界的商业精英、企业家代表齐聚一堂，共同聚焦西双版纳州的产业发展新机遇。备受尊敬的洪子晴爵士作为特邀嘉宾出席了此次盛会，并在会上发表了重要讲话，为西双版纳州的产业发展和招商引资工作建言献策。',
          img:require("@/assets/img/article/0613/4.webp")
        },
        {
          title: '热烈庆祝洪子晴爵士担任国际潮商会长俱乐部名誉主席',
          profile:'2025年6月7日，国际潮商会长俱乐部迎来了一项重大人事任命，备受尊敬的洪子晴爵士正式出任俱乐部名誉主席一职。这一决定在潮商群体以及商界、慈善界引发了广泛关注与热烈反响。洪子晴爵士在商业领域建树颇丰，作为深圳晴天集团董事局主席，她带领集团在产业投资、金融资本、艺术品及文化传媒、科技新零售、新能源汽车、智慧停车、珠宝平台、农业云平台及乡村振兴、生物医药、大健康，3D打印、短剧、生命科学等10多个领域全面布局，展现出卓越的商业战略眼光与领导才能。她是金运佳集团控股有限公司董事局主席、洪氏资产管理有限公司主席，深圳晴天集团董事局主席，她在资本市场长袖善舞，旗下多家公司在不同领域持续创造佳绩。在慈善公益方面，洪子晴爵士更是不遗余力。2008年，她毅然成立洪子晴慈善基金会，自成立以来，她已向基金会捐助个人资金超一亿元。基金会长期致力于帮助贫苦大众，在贫困山区建学校，为农村建医疗诊所，帮助贫困家庭，助养孤儿，探访老人及助建水窖等，积极参与赞助各类慈善机构活动，成为慈善领域的一面旗帜。多年来，洪子晴爵士身体力行，践行慈善理念，其善举赢得了社会各界的高度赞誉。洪子晴爵士不仅在商业与慈善领域成绩斐然，在社会职务与行业影响力方面同样不容忽视。她身兼数职，包括中国青海省十一届省政协特邀委员、中国深圳市福田区政协第四届政协委员，深圳市福田历届政协常委、中国广东省汕头市第十一届、第十二届政协委员、香港中华工商总会执行主席、香港国际投资总会執行主席、香港汕头商会永远荣誉会长、香港区潮人联会永远荣誉会长、香港孔教学院永远荣誉院长、香港新界社团联会名誉会长、深圳文化创意行业协会主席团主席、中国广东省汕头巿公益基金会理事会名誉会长、中国深圳汕头商会永远名誉会长、中国亚洲经济发展协会港澳首席代表、中国企业战略发展研究会终身名誉主席、世界华人精英联合会总会长、洪子晴生命科学基金主席、亚太经济领袖联合会永远荣誉主席、洪子晴荣获印尼苏丹王册封拿督斯里、中国香港国际经贸合作协会中国投资委员会联席主席等，在不同平台为地区发展、行业交流以及社会公益事业积极贡献力量。',
          img:require("@/assets/img/article/0612/4.webp")
        }
      ]
    }
  },
  data(){
    return {
    }
  },
  methods: {
    handleNavigate(url, index)
    {
      this.$router.push(url + "?articleIndex=" + index)
    }
  }
}
</script>
<style lang="scss" scoped>
//晴天动态
.dynamic{
  position: relative;
  background: url("../../assets/img/home/1746602841_rvJN.jpg") no-repeat;
  background-size: 100% 100%;
  font-family: $font-family;
  @media screen and (max-width: 768px) {
    background:none;
  }
  .dynamic_title{
    text-align: center;
    color: #203040;
    font-size: $title-font-size;
    font-weight: bold;
    padding: 60px 0 0 30px;
    @media screen and (max-width: 768px) {
      font-size: $phone-title-font-size;
      margin-top:-1rem;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
    }
  }
  .dynamic_sub{
   text-align: center;
    color: #fccc0c;
    font-size: $subtitle-font-size;
    @media screen and (max-width: 768px) {
      font-size: $phone-subtitle-font-size;
      margin-top:-1rem;
      position: absolute;
      left:50%;
      transform: translateX(-50%);
      top: 4.5%;
    }
  }
  .introduced{
    padding: 80px 0 60px 0;
    margin: 0 300px;
    display: flex;
    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
      margin:0px 1rem;
    }
    .introduced_left{
      display: flex;
      width: 60%;
      border-right: 1px solid rgba(0, 0, 0, .06);
      @media screen and (max-width: 768px) {
        width: 100%;
        border-right:none;
        display: flex;
        justify-content: space-between;
        margin-top:4rem;
      }
      .each{
        width: 346.5px;
        margin-right: 50px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          width: 48%;
          margin-right:0;
        }
        .picture{
          width: 100%;
          height: 240px;
          overflow: hidden;
          @media screen and (max-width: 768px) {
            height: 10rem;
          }
          img{
            height: 100%;
            width: 100%;
          }
        }
        .describes{
          background: #ffffff;
          padding:1rem 1rem;
          @media screen and (max-width: 768px) {
            border: 1px solid #eeeeee;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            margin-left: 0px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          .title{
            line-height: 24px;
            height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;
            font-size: 1.2rem;
            margin-bottom: 14px;
            display: block;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
              height: 2rem;
              line-height: 2rem;
            }
          }
          .details{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            color: #6f6f6f;
            margin-bottom: 20px;
            height: 48px;
            font-size: 0.8rem;
            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 10rem;
              line-height: 1.5rem;
              max-height: 4.5rem;
              margin-bottom: 0;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              color: rgb(127, 127, 127)
            }
          }
          .more{
            font-size: 14px;
            color: #999;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @media screen and (max-width: 768px) {
              display: none;
            }
          }
        }
        &:hover{
          .describes{
            .title{
              color: #794bb7 !important;
            }
            .more{
              color: #794bb7 !important;
            }
          }
          img{
            transform: scale(1.1);
            transition: transform .5s;
          }
        }
      }
    }
    .introduced_right{
      width: 40%;
      display: flex;
      flex-direction: column;
      margin-left: 40px;
      @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        flex-direction:row;
        justify-content: space-between;
        width: 100%;
        margin-left:0;
        margin-top: 0.5rem;
      }
      .each{
        margin-bottom: 36px;
        cursor: pointer;
        &:hover{
          .describes{
            .title{
              color: #794bb7 !important;
            }
            .more{
              color: #794bb7 !important;
            }
          }
          img{
            transform: scale(1.1);
            transition: transform .5s;
          }
        }
      }
      .each,.marginBottom{
        display: flex;
        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          width: 48%;
          border: 1px solid #eeeeee;
          box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
        }
        .picture{
          width: 30%;
          height: 120px;
          overflow: hidden;
          @media screen and (max-width: 768px) {
            width: 100%;
            height: 10rem;
          }
          img{
            height: 100%;
            width: 100%;
          }
        }
        .describes{
          width: 70%;
          margin-left: 30px;
          @media screen and (max-width: 768px) {
            width: 100%;
            padding-top: 0.8rem;
            padding-bottom: 0.7rem;
            margin-left: 0px;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          .title{
            font-size: 0.96rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-break: auto;
            -webkit-box-orient: vertical;
            /* text-align: justify; */
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            margin-bottom: 10px;
            color: #333;
            font-weight: bolder;
            @media screen and (max-width: 768px) {
              -webkit-line-clamp: 1;
              font-size: 1rem;
              max-height: 4rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              height: 2rem;
              line-height: 2rem;
            }
          }
          .details{
            font-size: 0.8rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-height: 24px;
            max-height: 48px;
            color: #6f6f6f;
            margin-bottom: 20px;
            height: 48px;
            @media screen and (max-width: 768px) {
              font-size: 0.8rem;
              height: 10rem;
              line-height: 1.5rem;
              max-height: 4.5rem;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              color: rgb(127, 127, 127);
            }
          }
        }
      }
      .marginBottom{
        margin-bottom: 0px;
      }
    }
  }
}
</style>
